import { useContext, useEffect, useState } from "react";
import CartContext from "../../store/cart-context";
import CartIcon from "../Cart/CartIcon";
import styles from "./HeaderCartButton.module.css";

const HeaderCartButton = (props) => {
  const [isButtonAnimated, setIsButtonAnimated] = useState(false);
  const cartContext = useContext(CartContext);

  const cartItemsNumber = cartContext.items.reduce((currentValue, item) => {
    return currentValue + item.amount;
  }, 0);

  const buttonClasses = `${styles.button} ${
    isButtonAnimated ? styles.bump : ""
  }`;

  useEffect(() => {
    if (isButtonAnimated) {
      const timer = setTimeout(() => {
        setIsButtonAnimated(false);
      }, 300); // Закінчуємо анімацію після 300 мс
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isButtonAnimated]); // Запускаємо ефект тільки при зміні стану isButtonAnimated

  const buttonClickHandler = () => {
    setIsButtonAnimated(true); // Запускаємо анімацію при кліці на кнопку
    props.onClick(); // Викликаємо обробник кліку, переданий ззовні
  };

  return (
    <button className={buttonClasses} onClick={buttonClickHandler}>
      <span className={styles.icon}>
        <CartIcon />
      </span>
      <span>Корзина</span>
      <span className={styles.badge}>{cartItemsNumber}</span>
    </button>
  );
};

export default HeaderCartButton;
